module.exports = __webpack_public_path__ + "static/img/space-man.f70e76a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/space-man.png
// module id = EHnf
// module chunks = 1